import React from 'react';
import FormularioCalificacion from './ratings/FormularioCalificacion';
import ListaReviews from './ratings/ListaReviews';
import { useAuth } from '../contexts/AuthContext';

const TrackDetail = ({ track, onClose }) => {
  const { user } = useAuth();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.9)',
      zIndex: 1000,
      overflowY: 'auto'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '20px auto',
        backgroundColor: '#1a1a1a',
        borderRadius: '10px',
        padding: '30px',
        color: 'white'
      }}>
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          style={{
            float: 'right',
            backgroundColor: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '24px',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>

        {/* Info de la canción */}
        <div style={{display: 'flex', gap: '20px', marginBottom: '30px'}}>
          {track.album?.cover_medium && (
            <img
              src={track.album.cover_medium}
              alt={track.title}
              style={{width: '150px', height: '150px', borderRadius: '8px'}}
            />
          )}
          <div>
            <h2 style={{fontSize: '28px', fontWeight: 'bold', marginBottom: '10px'}}>
              {track.title}
            </h2>
            <p style={{fontSize: '18px', color: '#b3b3b3', marginBottom: '5px'}}>
              {track.artist?.name}
            </p>
            <p style={{fontSize: '14px', color: '#666'}}>
              {track.album?.title}
            </p>
          </div>
        </div>

        {/* Sistema de calificación */}
        <div style={{marginTop: '40px'}}>
          <h3 style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '20px'}}>
            Califica esta canción
          </h3>
          
          {user ? (
            <>
              <FormularioCalificacion
                entityId={track.id.toString()}
                entityType="track"
                userId={user.id}
                entityName={track.title}
                entityArtist={track.artist?.name}
                entityAlbum={track.album?.title}
                entityImage={track.album?.cover_small}

              />
              
              <div style={{marginTop: '40px'}}>
                <h3 style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '20px'}}>
                  Reviews de otros usuarios
                </h3>
                <ListaReviews
                  entityId={track.id.toString()}
                  entityType="track"
                />
              </div>
            </>
          ) : (
            <p style={{color: '#b3b3b3'}}>Inicia sesión para calificar esta canción</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackDetail;